import React, {Component, Fragment} from 'react';

class MiniChartsByStateAndCounty extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    
    componentDidMount() {
        this.initDashboard1();
    }

    render() {
        return (
        <div className="miniChartsByStateAndCounty">
            <div>
                <p id="lastUpdate" className="input-sub-title"></p>
            </div>
            <div id="line-chart-controls" className="p-2">
                <form>
                    <div className="form-row">
                        <div className="form-group col-sm-12 mb-0">
                            <div className="form-row row justify-content-center">
                                <div className="form-group col-md-4 col-sm-9 col-10 mb-0">
                                    <label className="input-title">State</label>
                                    <select className="form-control" id="stateDropdown"></select>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div id="chart" className="w-100"></div>
        </div>
        )
    }
    
    initDashboard1 = () => {
        let selectedState = 'All';
        let selectedStateText = 'All';
        let data;
        let countyData;
        let filteredData;
        let v1;
        let view;
        let statData = {};
        let rawData = [];
        let rawStateData = [];

        let new_data = window.new_data;
        let d3 = window.d3;
        let timeRange = window.timeRange;
        let _ = window._;
        let vegaTooltip = window.vegaTooltip;
        let vega = window.vega;
        let vegaLite = window.vegaLite;
        let vl = window.vl;
        let vegaEmbed = window.vegaEmbed;
        
        new_data.forEach((d, i) => {
            var stateDataAdded = false;
            if (d.state !== '') {
                if (!statData[d.state]) {
                    statData[d.state] = {county: {}}
                }
                if ((d.county.includes('state') || !d.county.includes(',') || d.county.split(',')[0].trim().toUpperCase() === d.county.split(',')[1].trim().toUpperCase()) && !statData[d.state].data) {
                    statData[d.state].data = d;
                    statData[d.state].data.confirmed = [];
                    statData[d.state].data.deaths = [];
                    stateDataAdded = true
                }
                d.day.forEach((date, i) => {
                    if(d.tstpos[i] && d.mort[i])
                    {
                    
                    const newDate = "20" + date[4] + date[5] + '-' + date[0] + date[1] + '-' + date[2] + date[3];
                    var day = new Date(newDate);
                    // TODO: WHY IS DATE LAGGING BY ONE WHEN PROCESSING DATA HERE?
                    day.setDate(day.getDate() + 1)
                    day = day.toDateString();
                    const county = d.county.split(',')[0];
                    if (!d.county.includes("(state)")) {
                        let textCounty = d.county.includes('state') ? d.county.replace('(state)', '') : d.county.split(',')[0]
                        textCounty = textCounty.includes('County') ? textCounty.replace('County', '') : textCounty;
                        rawData.push({
                            county: textCounty,
                            state: statData[d.state].data.county.includes('state') ? statData[d.state].data.county.replace('(state)', '') : statData[d.state].data.county.split(',')[0],
                            stateCode: d.state,
                            fips: d.fips,
                            date: newDate,
                            cases: d.tstpos[i] ? d.tstpos[i] : 0,
                            deaths: d.mort[i] ? d.mort[i] : 0,
                            rawTime: new Date(newDate).getTime(),
                            day: day,
                        })
                    } else {
                        let textCounty = d.county.includes('state') ? d.county.replace('(state)', '') : d.county.split(',')[0]
                        textCounty = textCounty.includes('County') ? textCounty.replace('County', '') : textCounty;
                        rawStateData.push({
                            county: textCounty,
                            state: statData[d.state].data.county.includes('state') ? statData[d.state].data.county.replace('(state)', '') : statData[d.state].data.county.split(',')[0],
                            stateCode: d.state,
                            fips: d.fips,
                            date: newDate,
                            cases: d.tstpos[i] ? d.tstpos[i] : 0,
                            deaths: d.mort[i] ? d.mort[i] : 0,
                            rawTime: new Date(newDate).getTime(),
                            day: day,
                        })
                    }
                    if (stateDataAdded) {
                        statData[d.state].data.confirmed.push([newDate, d.tstpos[i] ? d.tstpos[i] : 0]);
                        statData[d.state].data.deaths.push([newDate, d.mort[i] ? d.mort[i] : 0]);
                    } else {
                        if (!statData[d.state].county[county]) {
                            statData[d.state].county[county] = {
                                confirmed: [],
                                deaths: [],
                                fips: d.fips,
                                state: d.state,
                                county: d.county
                            }
                        }
                        statData[d.state].county[county].confirmed.push([newDate, d.tstpos[i] ? d.tstpos[i] : 0]);
                        statData[d.state].county[county].deaths.push([newDate, d.mort[i] ? d.mort[i] : 0]);
                    }
                }
                })
            }
        });

        async function init() {
            // data = await getData();
            data = selectedState === "All" ? rawStateData : rawData;
            countyData = getCountryData(data);
            document.getElementById("chart").innerHTML = "";
            filteredData = getFilteredData(data, countyData)
            if (data) {
                // v1 = await getV1();
                createChart();
            }
        }

        function setSelectStateDropdown() {
            window.document.getElementById('stateDropdown').innerText = '';
            Object.keys(statData).forEach((key, i) => {
                var option = document.createElement('option');
                if (i === 0) {
                    option.innerText = 'Select State to see County data';
                    option.value = 'All';
                    option.id = 'allState';
                    option.selected = true;
                    document.getElementById('stateDropdown').appendChild(option);
                    option = document.createElement('option');
                }
                const stateText = statData[key].data.county.includes('state') ? statData[key].data.county.replace('(state)', '') : statData[key].data.county.split(',')[0]
                option.innerText = stateText;
                option.value = key;
                option.name = stateText;
                if (key === selectedState) {
                    option.selected = true;
                }
                document.getElementById('stateDropdown').appendChild(option)
            });
            document.getElementById('stateDropdown').addEventListener('change', (selected) => {
                selectedState = selected.target.value;
                document.getElementById('allState') ? document.getElementById('allState').innerText = "All States" : "";
                if (selectedState === "All") {
                    selectedStateText = "All States"
                } else {
                    let textCounty = statData[selectedState].data.county;
                    textCounty = textCounty.includes('state') ? textCounty.replace('(state)', '') : textCounty.split(',')[0];
                    textCounty = textCounty.includes('County') ? textCounty.replace('County', '') : textCounty;
                    selectedStateText = textCounty.trim();
                }
                init();
            })
        }

        function createChart() {
            timeRange = d3.extent(rawData, r => {
                return r.rawTime
            });
            document.getElementById("lastUpdate").innerHTML = `Last update: ${d3.utcFormat('%B %d, %Y')(new Date(timeRange[1]))}`;
            // setMark();
            // createMark();
            // const specMark = createMarkLine();
            const containerWidth = document.getElementById('chart').clientWidth;
            const clientWidth = containerWidth > 500 ? containerWidth - 220 : containerWidth < 346 ? 200 : 180;
            // const clientWidth = document.getElementById('chart').clientWidth;
            const columns = clientWidth < 500 ? containerWidth < 346 ? 2 : 3 : 6;
            const vlSpec = {
                "$schema": "https://vega.github.io/schema/vega-lite/v4.json",
                "data": {values: filteredData},
                "usermeta": {"embedOptions": {"renderer": "svg", actions: false}},
                // title: `COVID-19 in ${selectedStateText} by county (with at least 20 reported cases)`,
                facet: {"field": "county", type: 'nominal', title: ''},
                columns: columns,
                "autosize": {"type": "pad", "resize": true},
                spacing: 0,
                spec: {
                    width: clientWidth / columns,
                    height: clientWidth / columns,
                    "autosize": {"type": "pad", "resize": true},
                    "encoding": {
                        "x": {"field": "date", "type": "temporal", title: 'Time'},
                        "y": {
                            "field": "value",
                            "type": "quantitative",
                            title: 'Count',
                            axis: {labels: false}
                        },
                        "color": {"field": "type", "scale": {range: ['#008faa', '#f78e69']}, title: ''},
                    },
                    layer: [{
                        "mark": {type: "line", tooltip: {content: 'data'}},
                    }, {
                        "mark": {
                            type: "text", align: 'left', "dx": 8, dy: -6, fontSize: 12, fontWeight: 'bold',
                        },
                        "transform": [{"filter": `datum.rawTime == ${timeRange[1]} && datum.type === 'cases'`}],
                        "encoding": {
                            "text": {"field": "value", "type": "quantitative"},
                        }
                    }, {
                        "mark": {
                            type: "text", align: 'left', "dx": 8, dy: 6
                        },
                        "transform": [{"filter": `datum.rawTime == ${timeRange[1]} && datum.type === 'deaths'`}],
                        "encoding": {
                            "text": {"field": "value", "type": "quantitative", format: ',d'},
                        }
                    }, {
                        "mark": {type: "circle", size: 18, tooltip: {content: 'data'}},
                        "transform": [{"filter": `datum.rawTime == ${timeRange[1]} && datum.type !== 'new'`}],
                    }]
                },
                config: {
                    "view": {
                        "stroke": "transparent"
                    },
                    "autosize": {
                        "type": "fit",
                        "contains": "padding"
                    },
                    header: {
                        titleFontSize: 16,
                        labelFontSize: 14,
                        fontFamily: "ProximaNova-Regular",
                    },
                    axis: {
                        tickColor: "#424B54",
                        fontFamily: "ProximaNova-Regular",
                        grid: false,
                        ticks: false,
                    },
                    axisBottom: {labelFlush: true, grid: false},
                    title: {
                        fontSize: 16,
                        fontFamily: "ProximaNova-Bold",
                        offset: 20
                    },
                    legend: {
                        orient: "top",
                        "layout": {
                            "top": {
                                "anchor": clientWidth < 500 ? "middle" : "start"
                            }
                        },
                        offset: 20,
                        labelFontSize: 16,
                        fontFamily: "ProximaNova-Regular",
                    },
                    padding: {bottom: 20, top: 10, left: 0, right: 0}
                },
            };
            vegaEmbed('#chart', vlSpec).then(p => view = p.view);
            setTimeout(() => {
                if (d3.selectAll(".role-title")) {
                    const g = d3.selectAll(".role-title g:first-child").attr("transform", "translate(40,5)");
                    d3.selectAll(".role-title").attr("class", "role-title show");
                }
            }, 0)
        }

        async function getData() {
            let res = await d3.csv('https://cdn.jsdelivr.net/gh/nytimes/covid-19-data/us-counties.csv');
            if (res && res.length) {
                res = res.map(county => ({
                    ...county,
                    rawTime: new Date(county.date).getTime(),
                    cases: +county.cases,
                    deaths: +county.deaths,
                    day: new Date(county.date).toDateString(),
                }))
            }
            return res;
        }

        function getCountryData(dataGroup) {
            return _(dataGroup)
                .groupBy(({fips}) => `z${fips}`)
                .mapValues(rows => ({
                        maxCases: Math.max(...rows.map(row => row.cases)),
                        maxDeaths: Math.max(...rows.map(row => row.deaths)),
                    })
                ).value();
        }

        function getFilteredData(data, countyData) {
            return data
                .filter(({date}) => new Date(date) > new Date('2020-02-29'))
                .filter(({stateCode, county, cases}) => {
                    return (stateCode === selectedState || selectedState === "All") && county !== 'Unknown'
                })
                .filter(({fips}) => countyData[`z${fips}`].maxCases > 0)
                .map(({date, rawTime, day, state, county, cases, deaths}) => [
                    {date, rawTime, day, state, county, type: 'cases', value: cases},
                    {date, rawTime, day, state, county, type: 'deaths', value: deaths},
                ]).flat()
        }

        function getTitle(selectedState) {
            return `COVID-19 in ${selectedState} by county (with at least 20 reported cases)`;
        }

        async function getV1() {

            const options = {
                config: {
                    // vega-lite default configuration
                    config: {
                        view: {continuousWidth: 400, continuousHeight: 300},
                        mark: {tooltip: null}
                    }
                },
                init: view => {
                    // initialize tooltip handler
                    view.tooltip(new vegaTooltip.Handler().call);
                    // enable horizontal scrolling for large plots
                    if (view.container()) view.container().style['overflow-x'] = 'auto';
                },
                view: {
                    // view constructor options
                    loader: vega.loader({baseURL: 'https://vega.github.io/vega-datasets/'}),
                    renderer: 'canvas'
                }
            };

            return vl.register(vega, vegaLite, options);
        }

        function setMark() {
            //todo set width dynamically
            const width = 300;
            v1.markSquare({size: 2, opacity: 1})
                .data('data/zipcodes.csv')
                .transform(v1.calculate('substring(datum.zip_code, 0, 1)').as('digit'))
                .project(
                    v1.projection('albersUsa')
                )
                .encode(
                    v1.longitude().fieldQ('longitude'),
                    v1.latitude().fieldQ('latitude'),
                    v1.color().fieldN('digit')
                )
                .width(width)
                .height(Math.floor(width / 1.75))
                .autosize({type: 'fit-x', contains: 'padding'})
                .config({view: {stroke: null}})
                .render()
        }

        function createMark() {
            //todo set width dynamically
            const width = 100;
            const brush = v1.selectInterval().encodings('x');
            const click = v1.selectMulti().encodings('color');

            const scale = {
                domain: ['sun', 'fog', 'drizzle', 'rain', 'snow'],
                range: ['#e7ba52', '#a7a7a7', '#aec7e8', '#1f77b4', '#9467bd']
            };

            const plot1 = v1.markPoint({filled: true})
                .encode(
                    v1.color().value('lightgray')
                        .if(brush, v1.color().fieldN('weather').scale(scale).title('Weather')),
                    v1.size().fieldQ('precipitation').scale({domain: [-1, 50], range: [10, 500]}).title('Precipitation'),
                    v1.order().fieldQ('precipitation').sort('descending'),
                    v1.x().timeMD('date').axis({title: 'Date', format: '%b'}),
                    v1.y().fieldQ('temp_max').scale({domain: [-5, 40]}).axis({title: 'Maximum Daily Temperature (°C)'})
                )
                .width(width)
                .height(300)
                .select(brush)
                .transform(v1.filter(click));

            const plot2 = v1.markBar()
                .encode(
                    v1.color().value('lightgray')
                        .if(click, vl.color().fieldN('weather').scale(scale).title('Weather')),
                    v1.x().count(),
                    v1.y().fieldN('weather').scale({domain: scale.domain}).title('Weather')
                )
                .width(width)
                .select(click)
                .transform(v1.filter(brush));

            return v1.vconcat(plot1, plot2)
                .data('https://raw.githubusercontent.com/vega/vega/master/docs/data/seattle-weather.csv')
                .autosize({type: 'fit-x', contains: 'padding'})
                .render();
        }

        function createMarkLine() {
            //todo set width dynamically
            const width = 100;
            const domain = ['petalLength', 'petalWidth', 'sepalLength', 'sepalWidth'];

            const scale = {
                type: 'point',
                padding: 0
            };

            const axis = {
                domain: false,
                ticks: false,
                title: false,
                grid: true,
                gridColor: '#888',
                labelAngle: 0,
                labelPadding: 8,
                labelFontWeight: 'bold'
            };

            const lines = v1.markLine({
                strokeWidth: 1.5,
                opacity: 0.5
            })
                .encode(
                    v1.color().fieldN('species').sort('descending'),
                    v1.detail().fieldN('index'),
                    v1.x().fieldO('key').scale(scale).axis(axis),
                    v1.y().fieldQ('fraction').axis(null)
                );

            const labels = v1.markText({
                dx: -2,
                align: 'right',
                baseline: 'middle'
            })
                .transform(
                    v1.groupby('key').aggregate(v1.min('value').as('min'), v1.max('value').as('max')),
                    v1.fold('min', 'max').as('op', 'value'),
                    v1.groupby('key').window(v1.percent_rank('value').as('fraction'))
                )
                .encode(
                    v1.x().fieldN('key'),
                    v1.y().fieldQ('fraction').axis(null),
                    v1.text().fieldN('value')
                );

            const plot = v1.layer(lines, labels)
                .data('data/iris.json')
                .transform(
                    v1.window(v1.row_number().as('index')),
                    v1.fold(domain),
                    v1.groupby('key').join(v1.min('value').as('min'), v1.max('value').as('max')),
                    v1.calculate('(datum.value - datum.min) / (datum.max - datum.min)').as('fraction')
                )
                .width(width)
                .height(300)
                .autosize({type: 'fit-x', contains: 'padding'});

            return plot.render({renderer: 'svg'});
        }

        setSelectStateDropdown();
        init();
    }
}

export default MiniChartsByStateAndCounty;


// WEBPACK FOOTER //
// ./src/components/CovidDashboard/MiniChartsByStateAndCounty.js